import React, { useEffect, useState } from 'react'
import PostalMime from 'postal-mime'
import EmailContent from './EmailContent'

const EmlViewer = ({ blob }) => {
  const [email, setEmail] = useState(null)

  const updateImageLinks = (rawHtml, attachmentList) => {
    if (!rawHtml) {
      return rawHtml
    }

    let html = rawHtml.toString();

    return html.replace(/\bcid:([^'"\s]{1,256})/g, (match, cid) => {
      const attachment = attachmentList.find(att => att.contentId === `<${cid}>` && /^image\/\w+$/i.test(att.mimeType))
      if (attachment) {
        return 'data:' + attachment.mimeType + ';base64,' + btoa(String.fromCharCode(...new Uint8Array(attachment.content)))
      } else {
        console.log(`No match for ${cid}`, attachmentList)
        return match
      }
    });
  }

  useEffect(() => {
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const parsed = await new PostalMime().parse(reader.result);
        console.log(parsed)
        const newEmail = {
          subject: parsed.subject,
          date: parsed.date,
          from: parsed.from ? { name: parsed.from.name, email: parsed.from.address } : null,
          to: parsed.to ? parsed.to.map(recipient => ({ name: recipient.name, email: recipient.address })) : null,
          body: updateImageLinks(parsed.html, parsed.attachments),
          attachments: parsed.attachments.map(a => {
            const extension = a.filename.split('.').pop().toLowerCase()
            const mimeType = extension === 'pdf' ? 'application/pdf' : null
            const blob = mimeType ? new Blob([a.content], { type: mimeType }) : new Blob([a.content])
            const url = URL.createObjectURL(blob)
            return {
              name: a.filename,
              size: a.content.byteLength,
              contentId: a.contentId,
              isInline: a.related,
              fetchURL: url,
              downloadURL: url,
            }
          })
        }
        console.log(newEmail)
        setEmail(newEmail)
      } catch (error) {
        console.log(error)
      }
    };
    reader.readAsText(blob);
  }, [blob])

  return email ? <EmailContent email={email} /> : null


}

export default EmlViewer
